module.exports = __webpack_public_path__ + "static/media/Pasos_Fondo2.66711d30.png";